<template>
    <div id="app">
        <!-- header -->
        <van-nav-bar :title="title" fixed v-show="navViewShow" />
        <!-- 主體內容 -->
        <router-view @onTitle="getTitle" @onNavShow='getShow'></router-view>
        <!-- footer -->
        <!-- <tabbarView></tabbarView> -->
        <van-tabbar v-model="active" active-color="#6dd0cd" @change="onClickTabbarItem">
            <van-tabbar-item icon="home-o" to="/home">首頁</van-tabbar-item>
            <van-tabbar-item icon="filter-o" to="/assort">分類</van-tabbar-item>
            <van-tabbar-item icon="search" to="/search">搜尋</van-tabbar-item>
            <van-tabbar-item icon="shopping-cart-o" to="/cart" info="5">購物車</van-tabbar-item>
            <van-tabbar-item icon="manager-o" to="/mine">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    // import navView from "./components/navView/navView";
    // import tabbarView from "./components/tabbarView/tabbarView";
    // import { Tabbar, TabbarItem } from "vant";
    import { NavBar, Tabbar, TabbarItem } from "vant";
    export default {
        name: "app",
        components: {
            // navView,
            // tabbarView,
            [NavBar.name]: NavBar,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem
        },
        data() {
            return {
                title: "", //導航標籤(子組件傳遞)
                navViewShow: true,
                active: 0
            };
        },
        methods: {
            getTitle: function (title) {
                // console.log(title);
                this.title = title;
            },
            getShow: function (temp) {
                this.navViewShow = temp;
            },
            onClickTabbarItem: function () {
                // console.log(this.active);
                // 保存位置
                window.localStorage.setItem('itemIndex', this.active)
            }
        },
        created() {
            // 獲取保存資料
            var itemIndex = parseInt(window.localStorage.getItem('itemIndex'))
            //如果不是沒有數字，則返回保存之位置資料
            if (!isNaN(itemIndex)) {
                //itemIndex從0開始
                this.active = itemIndex
                //路徑
                var toPath = this.$router.options.routes[itemIndex + 1].path
                //跳轉到指定頁面中
                this.$router.push({ path: toPath })
            }
        }
    };
</script>

<style lang="scss">
    body {
        background-color: #f2f2f2;
    }
    #app {
        .van-nav-bar {
            background-color: #6dd0cd;
            height: 45px;
            font-size: 16px;
            line-height: 45px;
            text-align: center;
            .van-nav-bar__title {
                color: white;
                font-weight: bold;
                font-family: monospace, 微軟正黑體;
            }
        }
        /* 可以设置不同的进入和离开动画 */
        /* 设置持续时间和动画函数 */
        // 右到左
        .slide-to-left-enter-active,
        .slide-to-left-leave-active {
            transition: all 1s;
        }
        .slide-to-left-enter,
        .slide-to-left-leave-to {
            transform: translateX(100%);
        }
        // 向上
        .slide-to-top-enter-active,
        .slide-to-top-leave-active {
            transition: all 1s;
        }
        .slide-to-top-enter,
        .slide-to-top-leave-to {
            transform: translateY(100%);
        }
        //返回按鈕
        .van-nav-bar .van-icon {
            color: #f2f2f2;
            font-size: 16px;
        }
    }
</style>
